import apiClient from './apiClient';

// ============================================================
// Types — matching backend Go models for PWG5M4F1 (銷貨折讓單核准沖銷)
// backend/modules/pwg5m4f1/models/models.go
// ============================================================

export interface ReverseCandidate {
  fg140_01: string; // 折讓單號
  fg140_11: string; // 折讓日期
  fg140_12: string; // 公司代號
  fg140_14: string; // 折讓總淨額
  fg140_15: string; // 折讓總稅額
  fg140_80: string; // 核准狀態 (P)
}

export interface QueryResponse {
  items: ReverseCandidate[];
  total: number;
}

export interface ReverseResultItem {
  doc_key: string;
  success: boolean;
  message?: string;
}

export interface ReverseResponse {
  results: ReverseResultItem[];
}

// ============================================================
// API methods
// ============================================================

export const pwg5m4Api = {
  /** Query sales allowance order candidates eligible for reversal (FG140_80='P') */
  async queryCandidates(startNo: string, endNo: string): Promise<QueryResponse> {
    const params: Record<string, string> = {};
    if (startNo.trim()) params['start_no'] = startNo.trim();
    if (endNo.trim()) params['end_no'] = endNo.trim();
    const res = await apiClient.get('/api/pwg5m4/candidates', { params });
    return res.data;
  },

  /**
   * Execute batch reversal for selected sales allowance orders.
   * PWG5M4-VAL-REVERSE-CONFIRM-DIALOG (human_approved 2026-07-23): backend
   * rejects any call missing an explicit confirmed:true with 422 + zero DB
   * mutation. Callers must only invoke this after the user has confirmed
   * (e.g. inside a Modal.confirm's onOk), same as pwg5m5f1/pwg504f1.
   */
  async reverse(items: string[], confirmed: boolean = true): Promise<ReverseResponse> {
    const res = await apiClient.post('/api/pwg5m4/reverse', { items, confirmed });
    return res.data;
  },
};
